// extracted by mini-css-extract-plugin
export default {"content":"qXu_k","anchor":"avXLW","root":"HFXcL"};